var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip } from "@mui/material";
import clsx from "clsx";
import { forwardRef } from "react";
import { useStyles } from "./ui_tooltip.css";
export const UiTooltip = forwardRef((_a, ref) => {
    var { children, classes, maxWidth, PopperProps, onMouseMove, placement, variant = "info-gray", size = "small", title, offset } = _a, props = __rest(_a, ["children", "classes", "maxWidth", "PopperProps", "onMouseMove", "placement", "variant", "size", "title", "offset"]);
    const classesLocal = useStyles({ maxWidth, size, variant });
    if (typeof offset === "number") {
        PopperProps = Object.assign(Object.assign({}, PopperProps), { modifiers: [
                ...((PopperProps === null || PopperProps === void 0 ? void 0 : PopperProps.modifiers) || []),
                {
                    name: "offset",
                    options: {
                        offset: [0, offset],
                    },
                },
            ] });
    }
    if (title === undefined) {
        return children;
    }
    return (_jsx(Tooltip, Object.assign({ ref: ref, title: title, classes: Object.assign(Object.assign({}, classes), { arrow: clsx(classesLocal.arrow, classes === null || classes === void 0 ? void 0 : classes.arrow), popper: clsx(classesLocal.popper, classes === null || classes === void 0 ? void 0 : classes.popper), tooltip: clsx(classesLocal.tooltip, classes === null || classes === void 0 ? void 0 : classes.tooltip) }), PopperProps: PopperProps, placement: props.followCursor ? placement || "bottom-start" : placement }, props, { children: children })));
});
//# sourceMappingURL=ui_tooltip.js.map